import { useDispatch, useSelector } from 'modules/react-redux';
import { useCallback } from 'react';

import { cancelActivePopup } from '../../actions';
import { printPreviewPopupId } from '../../reducers/page/printPreviewPopupReducer';
import { getActivePopup } from '../../selectors/pageSelectors';

export const usePrintPreviewNotificationPopup = () => {
    const dispatch = useDispatch();

    const popup = useSelector(getActivePopup);
    const isOpen = popup?.id === printPreviewPopupId;

    const handleClose = useCallback(() => {
        dispatch(cancelActivePopup());
    }, [dispatch]);

    return {
        isOpen,
        handleClose,
    };
};
